module.exports = __webpack_public_path__ + "img/resc_6kl.3fcb5bbe.jpg";